
import { sizes, rotates, flips, countries } from '../static/enums';

export var getCountries = function getCountries() {
  return countries;
};

export var getCountryCodes = function getCountryCodes() {
  return countries.map(function (country) {
    return country.code;
  });
};

export var getFlips = function getFlips() {
  return flips;
};

export var getRotates = function getRotates() {
  return rotates;
};

export var getSizes = function getSizes() {
  return sizes;
};


//////////////////
// WEBPACK FOOTER
// /Users/leedongwei/Documents/Projects/crimp-application/node_modules/react-flag-icon-css/module/functions/props.js
// module id = 84
// module chunks = 0